// WebKit sometimes reports a bare, stackless "Load failed" unhandled rejection
// next to fetch failures Sentry already tagged with their host (GlitchTip
// 8757854). Remembering which fetches failed tells whether that rejection is
// one of them (an uncaught Firebase request) or a promise outside fetch.
const WINDOW_MS = 10_000
const MAX_ENTRIES = 20

const BARE_NETWORK_ERROR = /^(Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.)$/

interface Failure {
  host: string
  at: number
}

const recent: Failure[] = []
const failedErrors = new WeakSet<object>()

export function isBareNetworkErrorMessage(message: string): boolean {
  return BARE_NETWORK_ERROR.test(message)
}

export function hostOf(input: unknown): string {
  const raw = Array.isArray(input) ? input[0] : input
  const url = typeof raw === 'string' ? raw : raw instanceof URL ? raw.href : (raw as { url?: string } | null)?.url
  try {
    return url ? new URL(url).host : 'unknown'
  } catch {
    return 'unknown'
  }
}

export function noteFetchFailure(host: string, error: unknown, now = Date.now()): void {
  if (error && typeof error === 'object') failedErrors.add(error)
  recent.push({ host, at: now })
  if (recent.length > MAX_ENTRIES) recent.shift()
}

export function fetchFailureTags(error: unknown, now = Date.now()): Record<string, string> {
  const hosts = [...new Set(recent.filter(f => now - f.at <= WINDOW_MS).map(f => f.host))]
  return {
    bare_net_is_fetch_error: String(!!error && typeof error === 'object' && failedErrors.has(error)),
    bare_net_failed_hosts: hosts.join(',').slice(0, 200) || 'none',
    bare_net_online: String(typeof navigator === 'undefined' ? 'unknown' : navigator.onLine),
  }
}
